var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error-content',{attrs:{"code":"404","desc":"Oh~~您的页面好像飞走了~","src":_vm.src}})}
var staticRenderFns = []

export { render, staticRenderFns }